import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'languages',
    collectionActionName: 'APM_LANGUAGES',
    itemActionName: 'APM_LANGUAGE',
});
